import React, { Component } from 'react'
import { ParticipantsTable } from 'components/sections/participants'
import { apiConfiguration, apiParticipants } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { connect } from 'react-redux'

import { participants as participantsApi } from '../../../redux/modules/api'
import FilterAssessorActivityParticipants
  from '../../filters/FilterAssessorActivityParticipants/FilterAssessorActivityParticipants'
import FilterAssessorAJParticipants from '../../filters/FilterAssessorAJParticipants/FilterAssessorAJParticipants'
import FilterAssessorRPParticipants from '../../filters/FilterAssessorRPParticipants/FilterAssessorRPParticipants'
import { tableCommon } from '../../../helpers/decorators'



@tableCommon()
@apiConfiguration({
    getValues: [
        CONFIGURATION_KEYS.enableLabels.id,
        CONFIGURATION_KEYS.enableAwardLabels.id
    ]
})
@apiParticipants({
  assessorParticipantsList: true,
  filter: 'assessorParticipants'
})
@connect(
    ({ auth }) => ({
        activeOrganization: auth.organization
    }),
    {
        setAssessorActivityParticipantsFilter: participantsApi.setAssessorActivityParticipantsFilter,
        setAssessorAJParticipantsFilter: participantsApi.setAssessorAJParticipantsFilter,
        setAssessorRPParticipantsFilter: participantsApi.setAssessorRPParticipantsFilter,
        setAssessorActivityParticipantsParams: participantsApi.setAssessorActivityParticipantsParams,
        setAssessorAJParticipantsParams: participantsApi.setAssessorAJParticipantsParams,
        setAssessorRPParticipantsParams: participantsApi.setAssessorRPParticipantsParams

    }
)
class AssessorParticipants extends Component {
  render(){
      const {
          isAssessorActivityParticipants,
          isAssessorAJParticipants,
          isAssessorRPParticipants,
          setAssessorActivityParticipantsFilter,
          setAssessorAJParticipantsFilter,
          setAssessorRPParticipantsFilter,
          setAssessorActivityParticipantsParams,
          setAssessorAJParticipantsParams,
          setAssessorRPParticipantsParams
      } = this.props

      let setFilter

      let setParticipantsParams

      if(isAssessorActivityParticipants){
          setFilter = setAssessorActivityParticipantsFilter
          setParticipantsParams = setAssessorActivityParticipantsParams
      }

      if(isAssessorAJParticipants){
          setFilter = setAssessorAJParticipantsFilter
          setParticipantsParams = setAssessorAJParticipantsParams
      }

      if(isAssessorRPParticipants){
          setFilter = setAssessorRPParticipantsFilter
          setParticipantsParams = setAssessorRPParticipantsParams
      }

    return (
      <div>
          {isAssessorActivityParticipants && <FilterAssessorActivityParticipants />}
          {isAssessorAJParticipants && <FilterAssessorAJParticipants />}
          {isAssessorRPParticipants && <FilterAssessorRPParticipants />}
        <ParticipantsTable
            {...this.props}
            setFilter={setFilter}
            setParticipantsParams={setParticipantsParams}
            isAssessorParticipants />
      </div>
    )
  }
}

export default AssessorParticipants
